export default {"src":"/_next/static/media/linkedin.3408339b.svg","height":52,"width":94,"blurWidth":0,"blurHeight":0};